import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { WorkPage } from './pages/WorkPage';
import { ContactPage } from './pages/ContactPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen flex flex-col bg-[#F8F8F6]" data-id="element-2">
        <Navbar data-id="element-3" />
        <div className="flex-1" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/about" element={<AboutPage data-id="element-9" />} data-id="element-8" />
            <Route path="/services" element={<ServicesPage data-id="element-11" />} data-id="element-10" />
            <Route path="/work" element={<WorkPage data-id="element-13" />} data-id="element-12" />
            <Route path="/contact" element={<ContactPage data-id="element-15" />} data-id="element-14" />
            <Route path="/terms" element={<TermsPage data-id="element-17" />} data-id="element-16" />
            <Route path="/privacy" element={<PrivacyPage data-id="element-19" />} data-id="element-18" />
          </Routes>
        </div>
        <Footer data-id="element-20" />
      </div>
    </Router>;
}